export default __webpack_public_path__ + "assets/images/ccef7702f407a4d07374297891313696.svg";